export const AbroadCountriesRegions = {
  FRANCE: [
    'ALSACE',
    'BORDEAUX',
    'BURGUNDY',
    'LOIRE_VALLEY',
    'BEAUJOLAIS',
    'VALLEE_DU_RHONE',
    'LANGUEDOC_ROUSSILLON',
  ],
  GERMANY: ['MOSEL', 'PALATINATE', 'RHEINHESSEN'],
  ITALY: [
    'LAZIO',
    'TUSCANY',
    'TRENTINO_ALTO_ADIGE_AND_FRIULI',
    'VENETO',
    'SICILIA',
    'PIEDMONT',
    'TRENTINO_AND_ALTO_ADIGE',
    'MARSALA',
  ],
  PORTUGAL: ['VINHO_VERDE', 'DAO_BAIRRADA_AND_DOURO', 'PORTO'],
  SPAIN: [
    'MOLD',
    'RIOJA',
    'VALENCIA',
    'NAVARRE',
    'VALDEPENAS',
    'MADEIRA_AND_SETUBAL',
    'SHERRY',
  ],
  GREECE: ['SAMOS_AND_MUSCAT_DE_LEMNOS'],
  SLOVAKIA: ['TOKAJ'],
};
